import React, { forwardRef } from 'react';
import '@dtsl/css-select-menu/dist/index.css';
import PropTypes from 'prop-types';
import { SelectMenuProvider } from './context';
import { SelectMenuTypes } from './helper';
import SelectMenu from './SelectMenu';
import SelectMenuBody from './SelectMenu/SelectMenuBody/SelectMenuBody';
import SelectMenuControl from './SelectMenu/SelectMenuControl/SelectMenuControl';
import '@dtsl/css-utilities/dist/auto-positions/index.css';
import '@dtsl/css-utilities/dist/common-showcase/index.css';

// eslint-disable-next-line react/display-name
const SelectMenuWrapper = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    label,
    value,
    isError,
    readonly,
    disabled,
    removeTag,
    className,
    handleSearch,
    tooltipData,
    placeHolder,
    inputStyles,
    isLoading,
    defaultOpen,
    searchInPanel,
    isSearchable,
    requiredLabel,
    controlClassName,
    placeholderClassName,
    specificationText,
    arrowClassName,
    inlineSelectMenuStyles,
    isControlButton,
    controlButtonMetaData,
    selectMenuType,
    isMobile,
    searchValue,
    dataTestId,
    maxTagWidth,
    handleResetSearch,
    countTagWidth,
    isSearchClearable,
    isControlClearable,
    onClearControl,
    selectedFolderValue,
    isAbsoluteSelectMenu,
    autoPlacement,
    placement,
    isControlChip,
    controlChipMetaData,
    getPanelToggleState
  } = props;
  return /*#__PURE__*/React.createElement(SelectMenuProvider, {
    value: value,
    searchValue: searchValue,
    defaultOpen: defaultOpen,
    isMobile: isMobile,
    handleSearch: handleSearch,
    isLoading: isLoading,
    searchInPanel: searchInPanel,
    isSearchable: isSearchable,
    placeHolder: placeHolder,
    selectedFolderValue: selectedFolderValue,
    autoPlacement: autoPlacement,
    placement: placement,
    getPanelToggleState: getPanelToggleState
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    ref: ref,
    label: label,
    isError: isError,
    disabled: disabled,
    className: className,
    inputStyles: inputStyles,
    placeHolder: placeHolder,
    isSearchable: isSearchable,
    requiredLabel: requiredLabel,
    isControlButton: isControlButton,
    isControlChip: isControlChip,
    specificationText: specificationText,
    inlineSelectMenuStyles: inlineSelectMenuStyles,
    isAbsoluteSelectMenu: isAbsoluteSelectMenu,
    value: value,
    isMobile: isMobile,
    autoPlacement: autoPlacement
  }, /*#__PURE__*/React.createElement(SelectMenuControl, {
    readonly: readonly,
    disabled: disabled,
    removeTag: removeTag,
    tooltipData: tooltipData,
    placeHolder: placeHolder,
    selectMenuType: selectMenuType,
    isSearchable: isSearchable,
    arrowClassName: arrowClassName,
    isControlButton: isControlButton,
    controlClassName: controlClassName,
    inputStyles: inputStyles,
    placeholderClassName: placeholderClassName,
    controlButtonMetaData: controlButtonMetaData,
    dataTestId: dataTestId,
    maxTagWidth: maxTagWidth,
    countTagWidth: countTagWidth,
    isSearchClearable: isSearchClearable,
    isControlClearable: isControlClearable,
    onClearControl: onClearControl,
    handleResetSearch: handleResetSearch,
    isControlChip: isControlChip,
    controlChipMetaData: controlChipMetaData
  }), /*#__PURE__*/React.createElement(SelectMenuBody, props)));
});
SelectMenuWrapper.defaultProps = {
  label: '',
  defaultOpen: false,
  value: [],
  isError: false,
  readonly: false,
  disabled: false,
  className: '',
  placement: '',
  inputStyles: {},
  tooltipData: {},
  arrowClassName: '',
  controlClassName: '',
  removeTag: () => {},
  isSearchable: false,
  requiredLabel: false,
  specificationText: '',
  placeholderClassName: '',
  inlineSelectMenuStyles: {},
  isControlButton: false,
  controlButtonMetaData: {},
  selectMenuType: SelectMenuTypes.SINGLE_SELECTION,
  handleSearch: () => {},
  isLoading: false,
  searchInPanel: true,
  placeHolder: 'Select a condition',
  isMobile: false,
  // menuClassName: '',
  dataTestId: '',
  selectedFolderValue: {},
  isAbsoluteSelectMenu: false,
  maxTagWidth: 100,
  countTagWidth: 135,
  handleResetSearch: () => {},
  isSearchClearable: true,
  isControlClearable: false,
  searchValue: '',
  autoPlacement: false,
  isControlChip: false,
  controlChipMetaData: {},
  getPanelToggleState: () => {}
};
SelectMenuWrapper.propTypes = {
  maxTagWidth: PropTypes.number,
  countTagWidth: PropTypes.number,
  handleResetSearch: PropTypes.func,
  isSearchClearable: PropTypes.bool,
  isControlClearable: PropTypes.bool,
  onClearControl: PropTypes.func,
  label: PropTypes.string,
  defaultOpen: PropTypes.bool,
  isError: PropTypes.bool,
  value: PropTypes.array,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  removeTag: PropTypes.func,
  className: PropTypes.string,
  placement: PropTypes.string,
  placeHolder: PropTypes.string,
  inputStyles: PropTypes.object,
  tooltipData: PropTypes.object,
  isSearchable: PropTypes.bool,
  searchInPanel: PropTypes.bool,
  requiredLabel: PropTypes.bool,
  isControlButton: PropTypes.bool,
  arrowClassName: PropTypes.string,
  controlClassName: PropTypes.string,
  specificationText: PropTypes.string,
  placeholderClassName: PropTypes.string,
  inlineSelectMenuStyles: PropTypes.object,
  controlButtonMetaData: PropTypes.object,
  selectMenuType: PropTypes.string,
  isMobile: PropTypes.bool,
  selectedFolderValue: PropTypes.object,
  handleSearch: PropTypes.func,
  isLoading: PropTypes.bool,
  dataTestId: PropTypes.string,
  isAbsoluteSelectMenu: PropTypes.bool,
  searchValue: PropTypes.string,
  autoPlacement: PropTypes.bool,
  isControlChip: PropTypes.bool,
  controlChipMetaData: PropTypes.object,
  getPanelToggleState: PropTypes.func
};
export default SelectMenuWrapper;